module.exports = __webpack_public_path__ + "static/media/lambda.ede7fef7.svg";